// import appRun from './app.run';

function AppConfig($locationProvider, $urlRouterProvider, $stateProvider) {
  'ngInject';

  $locationProvider.html5Mode(true);
  $urlRouterProvider.otherwise('/');

  $stateProvider
    .state('app', {
      abstract: true,
      views: {
        '@': {
          template: '<app></app>'
        }
      }
    });
}

export default AppConfig;



/** WEBPACK FOOTER **
 ** ./client/app/app.config.js
 **/